import React, { useState } from 'react';
import { useUser } from '../utils/UserContext';
import TabBar from '../components/shared/TabBar';
import InnerTabsd from '../components/shared/InnerTabsd';
import { EditIcon, UserIcon2 } from '../components/shared/Icons';
import IssueTempPassword from './IssueTempPassword';
import MigratePayslips from './MigratePayslips';
import BulkBatchHashFields from './BulkBatchHashFields';
import FreshopsUpload from '../components/FreshopsUpload';
import Dashboard from './Dashboard';
import OnboardActive from './OnboardActive';





const TABS = [
  {
    id: 'users',
    label: 'IT Workflow',
  },
  {
    id: 'stafftimekeeping',
    label: 'Time Keeping',
  },
  {
    id: 'dashboardmain',
    label: 'Dashboard',
  },
  
];





const ITWORKLOAD_INNER = [
  { id: 'usersreset', label: 'Generate Password', icon: <UserIcon2 />, component: IssueTempPassword },
  { id: 'payslips', label: 'Migrate Payslips', icon: <UserIcon2 />, component: MigratePayslips },
  { id: 'bulkbatch', label: 'Bulk Hash Users', icon: <UserIcon2 />, component: BulkBatchHashFields },
  
  
];

const ITTIMEKEEPING_INNER = [
  { id: 'staffupload', label: 'Upload Freshops CSV', icon: <UserIcon2 />, component: FreshopsUpload },
  
 
  
  
  
];




const DASHBOARDSUPERVISOR_INNER = [
  { id: 'dashboadall', label: 'Main Dashboard', icon: <UserIcon2 />, component: Dashboard },
  { id: 'onboardactive', label: 'Onboarding', icon: <EditIcon />, component: OnboardActive },
  
  
];


const ItworkPage = () => {
  
  const [activeTab, setActiveTab] = useState('users');
  const { homeAccent } = useUser();

 


  return (
    <div className="fr-tab-page">
      <TabBar
        tabs={TABS}
        activeTab={activeTab}
        onTabChange={setActiveTab}
        homeRoute="/profile"
        homeColor={homeAccent}
      />
      <div className="fr-tab-content">
        {activeTab === 'users' && <InnerTabsd tabs={ITWORKLOAD_INNER}  defaultId="usersreset" />}
        {activeTab === 'stafftimekeeping' && <InnerTabsd tabs={ITTIMEKEEPING_INNER}  defaultId="staffupload" />}
         {activeTab === 'dashboardmain' && <InnerTabsd tabs={DASHBOARDSUPERVISOR_INNER} />}
        
      </div>
    </div>
  );
};



export default ItworkPage;